import { lookup } from "@repo/vihangam-yog-shared";

/**
 * The names the Emails page gives each kind of email the backend logs in
 * its send history (email_sends.type). Every type the backend writes has
 * a row here; emails-types.test.tsx reads the router to keep it that way.
 */
const EMAIL_TYPE_LABEL = {
  qr_pass: "Entry pass (QR code)",
  reminder: "Reminder",
  broadcast: "Invite past guests",
  pairing_invite: "Kund sharing invitation",
  directions: "Directions to the entrance",
  follow_up_attended: "Thank you for coming",
  follow_up_absent: "Sorry we missed you",
  place_confirmed: "Place confirmed (one person)",
  butwhy_thankyou: "But, why? thank-you",
  past_guest_correction: "Correction to past guests",
  past_guest_reminder: "Reminder to past guests",
  campaign_week: "September visit: the whole week",
  campaign_sunday: "September visit: the Sunday session",
  campaign_calendar: "September visit: short note",
  community_invite: "Community leaders invitation",
  community_reminder: "Community leaders reminder",
  community_last_call: "Community leaders last call",
  community_tonight: "Community leaders: tonight, last chance",
  hawan_allocation: "Your Kund (Hawan allocation)",
  hawan_see_you_tomorrow: "See you tomorrow (Hawan: where and when)",
  regents_park_today: "Regents Park tonight (Sydney people not yet invited)",
  hawan_where_to_come: "Where to come (Hawan: video of the walk in)",
  hawan_seat_change: "Your Kund has changed (Hawan)",
  community_bring_others: "Community leaders: bring someone",
  butwhy_pass: "But, why? see you Thursday (entry pass)",
  butwhy_tonight: "But, why? tonight (how the evening runs)",
  sydney_last_call: "Sydney last call for the weekend",
  visit_thank_you: "Thank you for the September visit",
  visit_follow_up: "Photos, feedback and online meditation",
} satisfies Record<string, string>;

/** The event slug the September visit and community sends are logged
 *  under. It isn't a catalogue event, so the backend sends the slug back
 *  as the title. */
export const ONE_OFF_EVENT_SLUG = "september-2026";

/** What the page calls that pseudo-event. */
export const ONE_OFF_EVENT_TITLE = "September visit";

/** Sends that go to community organisations rather than to people. */
export const ORGANISATION_EMAIL_TYPES: readonly string[] = [
  "community_invite",
  "community_reminder",
  "community_last_call",
  "community_tonight",
];

/** The thank-you after the visit, to everyone who registered. */
export const VISIT_THANK_YOU_EMAIL_TYPES: readonly string[] = [
  "visit_thank_you",
];

/** The follow-up after the visit: photos, the feedback form, donations. */
export const VISIT_FOLLOW_UP_EMAIL_TYPES: readonly string[] = [
  "visit_follow_up",
];

/** The September visit announcement, one type per version. */
export const SEPTEMBER_VISIT_EMAIL_TYPES: readonly string[] = [
  "campaign_week",
  "campaign_sunday",
  "campaign_calendar",
];

/** An email type's name, or null for a type this table doesn't know. */
export function emailTypeLabel(type: string): string | null {
  return lookup(EMAIL_TYPE_LABEL, type) ?? null;
}

/** Words for a type added to the backend after the table above
 *  ("some_new_email" reads "Some new email"), never a raw key. */
export function readableEmailType(type: string): string {
  const words = type.replace(/_+/g, " ").trim();
  return words ? `${words.charAt(0).toUpperCase()}${words.slice(1)}` : "Email";
}
